import { MessageDescriptor } from 'react-intl';
import {
    BannerZoneLocation,
    FeaturedTournamentZone,
    TimePeriod,
} from '@gin-betting/constants';
import core, { GQL } from '@gin-betting/core';

import globalMsgs from 'messages';
import { WidgetType } from './types';

const {
    constants: { SportType },
} = core;

export const NAME = 'promo' as const;

export const GET_FEATURED_TOURNAMENTS_REQUEST = `promo/GET_FEATURED_TOURNAMENTS:REQUEST` as const;
export const GET_FEATURED_TOURNAMENTS_SUCCESS = `promo/GET_FEATURED_TOURNAMENTS:SUCCESS` as const;
export const GET_FEATURED_TOURNAMENTS_FAIL = `promo/GET_FEATURED_TOURNAMENTS:FAIL` as const;

export const GET_MISSING_MATCHES_REQUEST = `promo/GET_MISSING_MATCHES:REQUEST` as const;

export const DEFAULT_CONFIG_LIST_SIZE = 5 as const;

export const ALL = 'all' as const;

export const WIDGETS = ['daily', 'weekly', 'monthly'] as const;

export const MARKET_LIMIT = 3 as const;

export const NUMBER_OF_ROWS = 5;

export const ZONE_LOCATIONS = [
    BannerZoneLocation.TOP_SPORT_EVENTS,
    BannerZoneLocation.POPULAR_SPORT_EVENTS,
    BannerZoneLocation.FAVORITES_SPORT_EVENTS,
] as const;

export const FEATURED_ZONES_MAPPING = {
    [SportType.Classic]: FeaturedTournamentZone.ClassicLeftWeb,
    [SportType.Esport]: FeaturedTournamentZone.EsportLeftWeb,
    [SportType.Mix]: FeaturedTournamentZone.MixLeftWeb,
};

export const FEATURED_SPORT_TYPE_MAPPING = {
    [GQL.FeaturedSportType.ESPORT]: SportType.Esport,
    [GQL.FeaturedSportType.CLASSIC]: SportType.Classic,
};

export enum FeaturedProviderConfigType {
    CustomList = 'CUSTOM_LIST',
    Tournament = 'TOURNAMENT',
}

export const MAPPING_ZONE = {
    [BannerZoneLocation.POPULAR_SPORT_EVENTS]: globalMsgs.popular,
    [BannerZoneLocation.TOP_SPORT_EVENTS]: globalMsgs.top,
    [BannerZoneLocation.FAVORITES_SPORT_EVENTS]: globalMsgs.favorites,
};

export const MAPPING_PERIOD: {
    [key in WidgetType]: MessageDescriptor;
} = {
    daily: globalMsgs.daily,
    weekly: globalMsgs.weekly,
    monthly: globalMsgs.monthly,
};

export const MOBILE_TOP_MATCH_LIST_INDEX_CONFIG: {
    [key in WidgetType]: number;
} = {
    daily: TimePeriod.Daily,
    weekly: TimePeriod.Weekly,
    monthly: TimePeriod.Monthly,
};

export const matchPropsToPick = [
    'id' as const,
    'marketsCount' as const,
    'sportId' as const,
    'score' as const,
    'tournament' as const,
    'startTime' as const,
    'streams' as const,
    'status' as const,
    'liveCoverage' as const,
    'slug' as const,
    'meta' as const,
];

export const marketPropsToPick = [
    'id' as const,
    'name' as const,
    'odds' as const,
];

export const oddsPropsToPick = [
    'id' as const,
    'name' as const,
    'competitorIds' as const,
];

export const tournamentPropsToPick = [
    'id' as const,
    'name' as const,
    'slug' as const,
];
